import _               from 'lodash'
import PropTypes       from 'prop-types'
import React           from 'react'
import { withRouter  } from 'react-router'
import { Link        } from 'react-router-dom'
import { FormControl } from 'react-bootstrap'

import { Keyboard         } from 'alto-react-components/lib/components'
import { login, LoginLink } from 'alto-react-client-auth/lib/routes'
import { ClientLogin      } from 'alto-react-client-auth/lib/components'
import { terminalLogin    } from 'alto-react-canteen/lib/routes'

class WebLogin extends ClientLogin.WrappedComponent
  @contextTypes =
    auth:     PropTypes.object
    backend:  PropTypes.object
    settings: PropTypes.object

  constructor: (props, context) ->
    super(props, context)

    return props.history.replace(login) unless props.history.location.state?.terminal? # missing state

    @isTerminal            = props.history.location.state.terminal
    @showKeyboard          = @isTerminal

    if @showKeyboard
      @keyboardRef = React.createRef()
      @passwordRef = React.createRef()

      @state.keyboardInput = if @state.useClientSelect then 'clientSearch' else 'username'

    if @state.useClientSelect
      @clientSelectRef = React.createRef()

  clientSelectProps: ->
    _.assign({ ref:      @clientSelectRef, \
               onToggle: (open) => @setKeyboardInput('clientSearch') if open },
             super())

  usernameControlProps: ->
    _.assign({ onFocus: => @setKeyboardInput('username') }, super())

  passwordControlProps: ->
    if @showKeyboard
      additionalProps =
        inputRef: (ref) => @passwordRef = ref
        onFocus:        => @setKeyboardInput('password')

      _.assign(additionalProps, super())
    else
      super()

  additionalRender: ->
    if @showKeyboard
      <Keyboard
       ref={@keyboardRef}
       value={@state[@state.keyboardInput]}
       onChange={(value) => @setState([@state.keyboardInput]: value)}
       onAccepted={@keyboardAccepted.bind(@)} />

  additionalInfo: ->
    paragraphs = super()

    if @isTerminal
      terminalLoginSwitch =
        <p key='terminal-login-switch'><Link to={terminalLogin}>Přihlásit se kartou</Link></p>

      paragraphs.unshift(terminalLoginSwitch)

    paragraphs

  onClientSelectSwitched: (event) ->
    super(event)

    @setKeyboardInput(if @state.useClientSelect then 'username' else 'clientSearch')

  setKeyboardInput: (input) ->
    if @showKeyboard and input != @state.keyboardInput
      @keyboardRef.current.resetKeyboard()
      @setState(keyboardInput: input)

  keyboardAccepted: ->
    focusPassword = => setTimeout((=> @passwordRef.focus()), 10)

    if @state.keyboardInput == 'clientSearch'
      focusPassword() if @clientSelectRef.current.submitSearch()
    else if @state.keyboardInput == 'username'
      focusPassword()
    else
      @submit() if @isValid()

  logIn: ->
    # is @auth.isTerminal set soon enough?
    # - if not, CanteenProfileNavLink will render the full 'edit profile' nav link instead of
    # 'change password'
    super().then => @context.auth.isTerminal = @isTerminal

export default withRouter(WebLogin)
